import React from 'react';
import { FaArrowLeft, FaChartBar, FaClock } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './ActivityVisualization.css';

const ActivityVisualization: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="activity-vis-container">
      <div className="activity-vis-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <FaArrowLeft /> Back
        </button>
        <h1>Daily Activity Visualization</h1>
      </div>
      
      <div className="activity-vis-description">
        <p>
          <FaChartBar style={{ marginRight: '8px', color: '#e50914' }} />
          This interactive visualization displays my daily activities and time allocation as moving bubbles.
          Each cluster represents a category of activity, with the size indicating approximate time spent per thought and/or activity.
          <span className="tech-note"> <FaClock style={{ marginRight: '5px' }} /> ....</span>
        </p>
      </div>
      
      <div className="activity-vis-content">
        <iframe 
          src="https://Anyaoha.github.io/docs/my_daily_activities/my_daily_thoughts.html" 
          height="850px" 
          width="100%" 
          frameBorder="0"
          title="Activity Visualization"
          loading="lazy"
          className="activity-iframe"
          allow="fullscreen"
        />
      </div>
      
      <div className="activity-vis-footer">
        <p>
          This visualization demonstrates my approach to data analysis and visualization.
          The clusters represent different activities tracked over time, providing insights into my daily routines and priorities.
        </p>
      </div>
    </div>
  );
};

export default ActivityVisualization; 